var Loader;

module.exports = Loader = {
    /**
     * @param  {string}                language     The language
     * @param  {app.i18n.I18nService}  i18nService  The i18n service instance.
     * @returns  {Promise}             A promise that will resolve when the
     *                                 translation is loaded.
     * @public
     */
    load: function(language, i18nService) {
        var promise,
            resolver,
            rejector;

        promise = new Promise(function(resolve, reject) {
            resolver = resolve;
            rejector = reject;
        });

        switch (language) {
            case "nl":
                require.ensure(["./nl/i18n.js"], function(require) {
                    // Unfortunately we can't use aliases here. However, we can
                    // use dynamic naming thanks to require.ensure.
                    Loader.apply(require("./nl/i18n.js"), i18nService);
                    resolver();
                }, function(error) {
                    rejector(error);
                }, "i18n-nl");
                break;
            case "de":
                require.ensure(["./de/i18n.js"], function(require) {
                    // Unfortunately we can't use aliases here. However, we can
                    // use dynamic naming thanks to require.ensure.
                    Loader.apply(require("./de/i18n.js"), i18nService);
                    resolver();
                }, function(error) {
                    rejector(error);
                }, "i18n-de");
                break;
            case "en":
            default:
                require.ensure(["./en/i18n.js"], function(require) {
                    // Unfortunately we can't use aliases here. However, we can
                    // use dynamic naming thanks to require.ensure.
                    Loader.apply(require("./en/i18n.js"), i18nService);
                    resolver();
                }, function(error) {
                    rejector(error);
                }, "i18n-en");
                break;
        }

        return promise;
    },

    /**
     * @param  {Object}                languagePack  The language
     * @param  {app.i18n.I18nService}  i18nService   The i18n service instance.
     * @private
     */
    apply: function(languagePack, i18nService) {
        languagePack.init(i18nService);
        i18nService.set("translation", languagePack.translation);
    }
};
